import '../../css/sections/ContactSection.css';
import { useInView } from 'react-intersection-observer';
import { motion } from "framer-motion";
import { TextGenerateEffect } from "../ui/text-generate-effect";

function ContactSection() {
    const { ref: contactRef, inView: contactInView } = useInView({
        triggerOnce: true,
        threshold: 0.3,
    });

    return (
        <div id='contact' className='contact-container'>
            <img
                src="/images/background1.svg"
                alt=""
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    repeat: 'no-repeat',
                    zIndex: 0,
                    pointerEvents: 'none',
                    opacity: 1
                }}
            />
            <motion.div className='contact-text'
                transition={{
                    duration: 0.3,
                    ease: "easeOut",
                }}
                ref={contactRef}
            >
                {contactInView && (
                    <>
                        <h1>LET´S <span className='special-font' style={{ fontStyle: "italic" }}>GET IN</span> TOUCH</h1>
                        <TextGenerateEffect
                            words="Please Contact Me Through One Of These Social Media Platforms If You Are Looking For Someone Who Loves His Work And Has Perseverance, Determination And A Never Give Up Attitude."
                        />
                    </>
                )}
            </motion.div>
            <div className='contact-items'>
                <motion.div whileHover={{
                    scale: [null, 1.025, 1.05],
                    transition: {
                        duration: 0.5,
                        times: [0, 0.6, 1],
                        ease: ["easeInOut", "easeOut"],
                    },
                }}
                    transition={{
                        duration: 0.3,
                        ease: "easeOut",
                    }} className='contact-item1' onClick={() => window.location.href = "mailto:samuel.banczik@gmail.com"}
                    style={{ cursor: 'pointer' }}><a href="mailto:samuel.banczik@gmail.com">EMAIL</a></motion.div>
                <motion.div whileHover={{
                    scale: [null, 1.025, 1.05],
                    transition: {
                        duration: 0.5,
                        times: [0, 0.6, 1],
                        ease: ["easeInOut", "easeOut"],
                    },
                }}
                    transition={{
                        duration: 0.3,
                        ease: "easeOut",
                    }} className='contact-item2' onClick={() => window.location.href = "https://www.linkedin.com/in/samuelbanczik/"}
                    style={{ cursor: 'pointer' }}><a href="https://www.linkedin.com/in/samuelbanczik/">LINKEDIN</a></motion.div>
                <motion.div whileHover={{
                    scale: [null, 1.025, 1.05],
                    transition: {
                        duration: 0.5,
                        times: [0, 0.6, 1],
                        ease: ["easeInOut", "easeOut"],
                    },
                }}
                    transition={{
                        duration: 0.3,
                        ease: "easeOut",
                    }} className='contact-item3' onClick={() => window.location.href = "https://github.com/SamuelBanczik"}
                    style={{ cursor: 'pointer' }}><a href="https://github.com/SamuelBanczik">GITHUB</a></motion.div>
                <motion.div whileHover={{
                    scale: [null, 1.025, 1.05],
                    transition: {
                        duration: 0.5,
                        times: [0, 0.6, 1],
                        ease: ["easeInOut", "easeOut"],
                    },
                }}
                    transition={{
                        duration: 0.3,
                        ease: "easeOut",
                    }} className='contact-item4' onClick={() => window.location.href = "https://www.instagram.com/ssmzxk"}
                    style={{ cursor: 'pointer' }}><a href="https://www.instagram.com/ssmzxk">INSTAGRAM</a></motion.div>
                <motion.div whileHover={{
                    scale: [null, 1.025, 1.05],
                    transition: {
                        duration: 0.5,
                        times: [0, 0.6, 1],
                        ease: ["easeInOut", "easeOut"],
                    },
                }}
                    transition={{
                        duration: 0.3,
                        ease: "easeOut",
                    }} className='contact-item5' onClick={() => window.location.href = "https://x.com/ssmzxk"}
                    style={{ cursor: 'pointer' }}><a href="https://x.com/ssmzxk">X</a></motion.div>
            </div>
            <div className='contact-footer' aria-hidden="true">
                <span>BANCZÍK</span>
            </div>
        </div>
    );
}

export default ContactSection;
